module.exports = __webpack_public_path__ + "img/23_66.6fb442ef.png";